export const PUSH_NOTIFICATION_SENT = 'PUSH_NOTIFICATION_SENT';

export const pushNotificationSent = ({ pushType }) => ({
    type: PUSH_NOTIFICATION_SENT,
    pushType,
});
